import { render, staticRenderFns } from "./CoordinatedAssessments.vue?vue&type=template&id=02c87931&"
import script from "./CoordinatedAssessments.vue?vue&type=script&lang=js&"
export * from "./CoordinatedAssessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports